// extracted by mini-css-extract-plugin
module.exports = {"spinAround":"CreateSiteForm_spinAround_NbHZr"};